// src/services/employeeService.js
// ─────────────────────────────────────────────────────────────────
// All API calls for employees (CRUD + manager followup).
// Uses the shared api/client.js which attaches the JWT automatically.
// ─────────────────────────────────────────────────────────────────

import api from "./api";

const employeeService = {

  // ── List with pagination / filters ────────────────────────────
  getAll(params = {}) {
    return api.get('/employees', { params });
  },

  // ── Single employee (with all calls + managerFollowup) ─────────
  getOne(id) {
    return api.get(`/employees/${id}`);
  },

  // ── Create ─────────────────────────────────────────────────────
  create(data) {
    return api.post('/employees', data);
  },

  // ── Update (general patch — can include managerFollowup) ───────
  // Used by: ManagerFollowupButton → sends { managerFollowup: { ... } }
  update(id, data) {
    return api.patch(`/employees/${id}`, data);
  },

  /**
   * Dedicated endpoint for Manager D-0 followup.
   * PATCH /employees/:id/manager-followup
   *
   * Body: { accompanied, ipadProvided, prathamCandidAtten,
   *         prathamMgrAtten, ipadStatus, mgrRemarks }
   */
  updateManagerFollowup(id, data) {
    return api.patch(`/employees/${id}/manager-followup`, data);
  },

  // ── Soft delete ────────────────────────────────────────────────
  remove(id) {
    return api.delete(`/employees/${id}`);
  },

  // ── Call History ─────────────────────────────────────────────
  // GET /employees/:id/call-history  — returns all history rows
  getCallHistory(id) {
    return api.get(`/employees/${id}/call-history`);
  },

  // GET /employees/:id/call-history/:callKey — history for one stage
  getCallHistoryByKey(id, callKey) {
    return api.get(`/employees/${id}/call-history/${callKey}`);
  },

  // ── Attrition stats (authoritative resigned count from attrition_records) ──
  getAttritionStats() {
    return api.get('/employees/attrition-stats');
  },

  // ── Bulk import (multipart Excel) ──────────────────────────────
  bulkImport(file, onProgress) {
    const form = new FormData();
    form.append('file', file);
    return api.post('/employees/bulk-import', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    });
  },
};

export default employeeService;